// *****************************************************************************
// Copyright (C) 2017 Ericsson and others.
//
// This program and the accompanying materials are made available under the
// terms of the Eclipse Public License v. 2.0 which is available at
// http://www.eclipse.org/legal/epl-2.0.
//
// This Source Code may also be made available under the following Secondary
// Licenses when the conditions for such availability set forth in the Eclipse
// Public License v. 2.0 are satisfied: GNU General Public License, version 2
// with the GNU Classpath Exception which is available at
// https://www.gnu.org/software/classpath/license.html.
//
// SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
// *****************************************************************************

import { injectable } from 'inversify';
import { Emitter, Event } from './event';
import { ILoggerClient, ILogLevelChangedEvent } from './logger-protocol';

@injectable()
export class LoggerWatcher {

    getLoggerClient(): ILoggerClient {
        const logLevelEmitter = this.onLogLevelChangedEmitter;
        const logConfigEmitter = this.onLogConfigChangedEmitter;
        return {
            onLogLevelChanged(event: ILogLevelChangedEvent): void {
                logLevelEmitter.fire(event);
            },
            onLogConfigChanged(): void {
                logConfigEmitter.fire();
            },
        };
    }

    protected onLogLevelChangedEmitter = new Emitter<ILogLevelChangedEvent>();

    get onLogLevelChanged(): Event<ILogLevelChangedEvent> {
        return this.onLogLevelChangedEmitter.event;
    }

    protected onLogConfigChangedEmitter = new Emitter<void>();

    get onLogConfigChanged(): Event<void> {
        return this.onLogConfigChangedEmitter.event;
    }
}
